import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { CTAButton } from './ui/CTAButton';
export function CountdownSection() {
  const {
    minutes,
    seconds,
    isUrgent
  } = useCountdown(15);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <section className="py-16 px-4 bg-white border-y-4 border-brand-amber" data-id="element-63">
      <div className="max-w-4xl mx-auto text-center" data-id="element-64">
        <h2 className="text-3xl md:text-4xl font-black text-brand-dark mb-4" data-id="element-65">
          ⏰ ATENCIÓN: Esta oferta tiene fecha de vencimiento real
        </h2>

        <p className="text-lg md:text-xl text-gray-700 mb-8 max-w-2xl mx-auto" data-id="element-66">
          El precio promocional de <strong data-id="element-67">$19.990</strong> está disponible por
          tiempo limitado. Después, el precio vuelve a{' '}
          <strong data-id="element-68">$49.900 ARS</strong>. No hay extensiones. No hay excepciones.
        </p>

        <div className={`flex justify-center gap-4 md:gap-8 mb-8 ${isUrgent ? 'animate-blink' : ''}`} data-id="element-69">
          <div className="flex flex-col items-center" data-id="element-70">
            <div className={`text-5xl md:text-7xl font-black p-4 md:p-6 rounded-xl shadow-inner min-w-[80px] md:min-w-[120px] ${isUrgent ? 'bg-red-600 text-white' : 'bg-brand-dark text-white'}`} data-id="element-71">
              {formatTime(minutes)}
            </div>
            <span className="text-gray-500 font-bold mt-2 uppercase" data-id="element-72">min</span>
          </div>
          <div className="text-5xl md:text-7xl font-black text-brand-dark self-start mt-2 md:mt-4" data-id="element-73">
            :
          </div>
          <div className="flex flex-col items-center" data-id="element-74">
            <div className={`text-5xl md:text-7xl font-black p-4 md:p-6 rounded-xl shadow-inner min-w-[80px] md:min-w-[120px] ${isUrgent ? 'bg-red-600 text-white' : 'bg-brand-amber text-white'}`} data-id="element-75">
              {formatTime(seconds)}
            </div>
            <span className="text-gray-500 font-bold mt-2 uppercase" data-id="element-76">seg</span>
          </div>
        </div>

        <p className="text-2xl font-bold text-red-600 mb-10" data-id="element-77">
          🔴 Después vuelve a $49.900 ARS — sin excepciones.
        </p>

        <div className="max-w-xl mx-auto" data-id="element-78">
          <CTAButton text="→ ASEGURAR MI PRECIO AHORA" href="https://checkout.guiadigital360.online/cart/43889650401349:1" isLink={true} data-id="element-79" />
        </div>
      </div>
    </section>;
}